import Label from './Label';
import { LabelProps, LabelValueProps } from './types';

export type { LabelProps, LabelValueProps };
export default Label;
